import { useMutation } from "@tanstack/react-query";
import { generateStockReport } from "services/stockreport";

export const useGenerateStockReport = () =>
  useMutation({
    mutationFn: (data) => generateStockReport(data),
  });
